export default __webpack_public_path__ + "static/media/arrowDown.abd791fa.svg";